import { render, staticRenderFns } from "./EraseAccount.vue?vue&type=template&id=29cb4ee8"
import script from "./EraseAccount.vue?vue&type=script&lang=js"
export * from "./EraseAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports